import React, { useContext, useEffect, useRef } from 'react';
import { useMediaQuery } from '@oneaudi/feature-app-utils';
import { StyledMainMenu, LeftContainer, RightContainer } from '../SubPageNavigationStyles';
import CtaSection from '../ui/CtaSection';
import SubmenuTrigger from '../ui/SubmenuTrigger';
import { Context } from '../../../context/Context';
import { attachHorizontalNavigation } from '../../../utils/a11y';
import { useI18n } from '../../../i18n';

const MainMenu: React.FC = () => {
  const notMobile = useMediaQuery('(min-width: 768px)');
  const { hasCta } = useContext(Context);
  const menuRef = useRef<HTMLElement>(null);
  const ariaLabel = useI18n('ariaMenu');

  useEffect(() => {
    if (menuRef.current) {
      attachHorizontalNavigation(menuRef.current);
    }
  }, []);

  return (
    <StyledMainMenu aria-label={ariaLabel} ref={menuRef}>
      <LeftContainer>
        <SubmenuTrigger />
      </LeftContainer>
      {notMobile && hasCta && (
        <RightContainer>
          <CtaSection />
        </RightContainer>
      )}
    </StyledMainMenu>
  );
};

export default MainMenu;
